import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import TabNavigation from 'components/common/TabNavigation';
import FacilityCreateEditForm from 'components/settings/FacilityCreateEditForm';

import { fetchFacility } from 'redux/modules/facilities';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class BusinessFacilityEdit extends Component {
  componentDidMount() {
    const { facility, actions, match } = this.props;
    if (!facility) {
      actions.fetchFacility({
        triggerLoading: true,
        ID: match.params.id,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { loading, history } = this.props;
    if (loading > 0
      && nextProps.loading === 0
      && !nextProps.facility) {
      history.replace('/settings/business/facilities');
    }
  }

  render() {
    const { facility, loading, history, account } = this.props;
    return (
      <Layout variant="settings">
        <TabNavigation
          items={[
            {
              text: 'General',
              href: '/settings/business/general',
            },
            {
              text: 'Facilities',
              href: '/settings/business/facilities',
            },
            ...account.Roles.filter(item =>
              item.Name === 'Master Administrator' || item.Name === 'Administrator').length > 0 ?
              [
                {
                  text: 'Claim MD Credentials',
                  href: '/settings/business/claim-md-credentials',
                },
                {
                  text: 'Twilio Credentials',
                  href: '/settings/business/twilio-credentials',
                },
              ] : [],
          ]}
        />
        {(loading > 0 || !facility) ? (
          <Progress />
        ) : (
          <Fragment>
            <Helmet>
              <title>
                {appTitle} {titleSeparator} Facilities {titleSeparator} {facility['Company Info']['Company Name']}
              </title>
            </Helmet>
            <FacilityCreateEditForm
              ID={facility.ID}
              form={`settingsFacilityEdit-${facility.ID}`}
              initialValues={{
                ...facility,
                ...facility.Image && facility.Image['File Name'] ? {
                  'Image': {
                    name: facility.Image['File Name'],
                    preview: `${facility.Image['File Url']}${facility.Image['File Name']}`,
                  },
                } : {},
                'Work Schedule': facility['Work Schedule'].map((schedule) => {
                  const formattedSchedule = Object.assign({}, schedule, {
                    'Weekday ID': schedule.Weekday.map(weekday => weekday.ID),
                  });
                  delete formattedSchedule.Weekday;
                  return formattedSchedule;
                }),
              }}
              onSubmitSuccess={() => {
                history.push('/settings/business/facilities');
              }}
            />
          </Fragment>
        )}
      </Layout>
    );
  }
}

BusinessFacilityEdit.propTypes = {
  facility: PropTypes.shape({
    ID: PropTypes.number,
  }),
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchFacility: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
};

BusinessFacilityEdit.defaultProps = {
  facility: null,
};

const mapStateToProps = (store, ownProps) => ({
  facility: store.facilities.data
    .find(facility => facility.ID === Number(ownProps.match.params.id)),
  loading: store.facilities.loading,
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchFacility }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BusinessFacilityEdit);



// WEBPACK FOOTER //
// ./src/pages/settings/BusinessFacilityEdit.js